import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { getCategoryAndProductId } from 'analytics/snowplow/helpers/itemCategorisation'
import { getAirportsSearch } from 'api/flights'
import { getPlaceByLatLong } from 'api/search'
import { mapCityLevelPlace } from 'lib/search/mappingUtils'

async function getFlightCheckoutItem(state: App.State, item: App.Checkout.FlightItem) {
  const journeyId = item.departing?.journeyId

  // get journey v1 and v2
  const journeysV1 = Object.values(state.flights.searchFlights).flatMap(flight => flight?.journeys)
  const journeyV1 = journeysV1.find(journey => journey?.id === journeyId)
  const journeysV2 = Object.values(state.flights.searchV2Flights)
    .flatMap(flight => flight?.departingFares)
  const journeyv2 = journeysV2.find(journey => journey?.id === journeyId)

  // get first and last flight from journey v1 and v2
  const firstDepartingFlightV1 = journeyV1?.departing?.flights[0]
  const firstDepartingFlightV2 = journeyv2?.flightGroup.flights[0]
  const lastDepartingFlightsV1 = journeyV1?.departing?.flights[journeyV1?.departing.flights.length - 1]
  const lastDepartingFlightsV2 = journeyv2?.flightGroup.flights[journeyv2?.flightGroup.flights.length - 1]

  // get departing and arrival airport latitude and longitude
  const departingAirportName = firstDepartingFlightV1?.departingAirportName ?? firstDepartingFlightV2?.departureAirportName
  const arrivalAirportName = lastDepartingFlightsV1?.arrivalAirportName ?? lastDepartingFlightsV2?.arrivalAirportName
  const departingAirport = departingAirportName ? await getAirportsSearch(departingAirportName) : undefined
  const arrivalAirport = arrivalAirportName ? await getAirportsSearch(arrivalAirportName) : undefined
  const destination: { city: string | undefined, region: string | undefined, country: string | undefined } = { city: undefined, region: undefined, country: undefined }
  const origin: { city: string | undefined, region: string | undefined, country: string | undefined } = { city: undefined, region: undefined, country: undefined }
  if (departingAirport && departingAirport?.length > 0 && arrivalAirport && arrivalAirport?.length > 0) {
    const departingLongitude = departingAirport[0].lg
    const departingLatitude = departingAirport[0].lt
    const arrivalLongitude = arrivalAirport[0].lg
    const arrivalLatitude = arrivalAirport[0].lt

    if (arrivalLongitude && arrivalLatitude) {
      // eg: [Melbourne, Victoria, Australia]
      const arrivalPlace = mapCityLevelPlace((await getPlaceByLatLong(arrivalLatitude, arrivalLongitude)))
      destination.city = arrivalPlace?.city
      destination.region = arrivalPlace?.region
      destination.country = arrivalPlace?.country
    }

    if (departingLongitude && departingLatitude) {
      // eg: [Melbourne, Victoria, Australia]
      const departingPlace = mapCityLevelPlace((await getPlaceByLatLong(departingLatitude, departingLongitude)))
      origin.city = departingPlace?.city
      origin.region = departingPlace?.region
      origin.country = departingPlace?.country
    }
  }

  // get costs and calculate price
  const departingCost = item.departing?.fareFamily?.cost.all || journeyV1?.cost || journeyv2?.price.all.totalFare
  const returningCost = item.returning?.fareFamily?.cost.all
  const price = departingCost && returningCost ? departingCost + returningCost : departingCost

  const { categoryId, productId } = getCategoryAndProductId(item.itemType)

  return comluxgroup.createItem_1_1_0({
    offerId: 'travelFusion',
    categoryId,
    productId,
    travelStart: firstDepartingFlightV1?.departingDate ?? firstDepartingFlightV2?.departingDate,
    travelEnd: lastDepartingFlightsV1?.arrivalDate ?? lastDepartingFlightsV2?.arrivalDate,
    numberOfAdults: item.occupants.adults,
    numberOfChildren: item.occupants.children,
    numberOfInfants: item.occupants.infants,
    childrenAges: item.occupants.childrenAge,
    price,
    currency: state.geo.currentCurrency,
    destinationCity: destination.city,
    destinationRegion: destination.region,
    destinationCountry: destination.country,
    originCountry: origin.country,
    originCity: origin.city,
    originRegion: origin.region,
    itemId: item.itemId,
    variant: item.fareType.toLowerCase(),
  })
}

export default getFlightCheckoutItem
